import { Stack, Card, Box } from 'braid-design-system';
import React from 'react';

const FormCard = ({ children }: { children: any }) => (
  <Card rounded>
    <Box padding={{ mobile: 'none', tablet: 'small', desktop: 'xlarge' }}>
      <Stack space="large">{children}</Stack>
    </Box>
  </Card>
);

export default FormCard;
